import type { Conversation } from '@customTypes/chat';
import type { RequestConfig } from '@customTypes/index';

import { api } from '@/shared/api/instance';

export type CreateConversationWithAdminParams = RequestConfig<{
  senderProfileId: string;
}>;

export const createConversationWithAdmin = async ({
  params,
  config
}: CreateConversationWithAdminParams) =>
  api.post<Conversation>(
    '/api/chat/conversations/private-admin',
    params,
    config
  );
